import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from '../../hooks/usePermission';

interface Props {
  anyOf: string[];
  children: ReactNode;
}

/** Route-level guard: redirects to /403 when the user lacks all listed permissions. */
export function RequirePermission({ anyOf, children }: Props) {
  const { hasAnyPermission } = usePermission();
  if (!hasAnyPermission(anyOf)) {
    return <Navigate to="/403" replace />;
  }
  return <>{children}</>;
}
